import { StubPage } from '../StubPage'
export function Paths() {
  return <StubPage title="Paths (Authorization)" summary="Paths define which API routes are allowed for a given role. Each path entry is a method + URL pattern pair. Roles inherit all paths assigned to them." />
}
